import catalogModule from '../catalogModule';
import menuConstants from '../constants/menuConstants';

function breadcrumbsController($log, $scope, catalogConstants, constantsService) {
  'ngInject';

  $scope.isSortAvailable = () => {
    return $scope.isSearchableCategory($scope.currentQuery.category);
  };

  $scope.showGenreBreadcrumb = () => {
    const genreBreadcrumb = $scope.getGenreBreadcrumb();
    return genreBreadcrumb && genreBreadcrumb.length > 0;
  };

  $scope.getGenreBreadcrumb = () => {
    const { genres } = $scope.navigationMenu;

    if (!genres) {
      return null;
    }

    const selectedGenres = genres.filter(genre => {
      return genre.isSelected;
    });

    const numOfGenresSelected = selectedGenres.length;

    if (numOfGenresSelected === 1) {
      return selectedGenres[0].name;
    }
    if (numOfGenresSelected === 2) {
      return constantsService.genreOrText(selectedGenres[0].name, selectedGenres[1].name);
    }
    if (numOfGenresSelected > 2) {
      return constantsService.genreTextSelected(numOfGenresSelected);
    }

    return null;
  };

  $scope.showCreatorBreadcrumb = () => {
    return $scope.data.creatorBreadcrumb && $scope.data.creatorBreadcrumb.length > 0;
  };

  $scope.showPriceBreadcrumb = () => {
    return $scope.showFreeBreadcrumb() || $scope.showCustomPriceBreadcrumb();
  };

  $scope.showFreeBreadcrumb = () => {
    return $scope.data.showFreeBreadcrumb;
  };

  $scope.showCustomPriceBreadcrumb = () => {
    if (
      !$scope.data.currencyType ||
      $scope.data.currencyType.currencyType !== $scope.library.customRobuxFilterId
    ) {
      return false;
    }

    if (!$scope.data.minPriceBreadcrumb && !$scope.data.maxPriceBreadcrumb) {
      $scope.data.showFreeBreadcrumb = true;
      return false;
    }

    const { minPriceBreadcrumb } = $scope.data;
    return typeof minPriceBreadcrumb === 'number' && minPriceBreadcrumb % 1 === 0;
  };

  $scope.isNonDefaultSubcategorySelected = () => {
    const cat = $scope.getCategoryOption($scope.currentQuery.category);

    if (!cat || !cat.subcategories || !$scope.currentQuery.subcategory) {
      return false;
    }

    const defaultSubcategory = cat.subcategories[0];
    return defaultSubcategory.subcategoryId !== $scope.currentQuery.subcategory.subcategoryId;
  };

  $scope.clearSubcategory = () => {
    const cat = $scope.getCategoryOption($scope.currentQuery.category);
    // Set subcategory to the default for the category if the category has a subcategory menu
    if (!cat || !cat.subcategories) {
      $scope.currentQuery.subcategory = null;
    } else {
      const defaultSubcategory = cat.subcategories[0];
      $scope.currentQuery.subcategory = defaultSubcategory;
    }

    $scope.clearGenres();
  };

  $scope.clearGenres = (stopChaining, keepKeyword) => {
    const { genres } = $scope.navigationMenu;

    if (genres) {
      for (let i = 0; i < genres.length; i++) {
        genres[i].isSelected = false;
      }
    }

    if (stopChaining) {
      $scope.clearKeyword();
      return;
    }

    $scope.clearCreator(false, keepKeyword);
  };

  $scope.clearCreator = (stopChaining, keepKeyword) => {
    $scope.data.creator = $scope.data.creators.find(creator => {
      return creator.userId === $scope.library.defaultCreatorId;
    });

    if (stopChaining) {
      $scope.clearKeyword();
      return;
    }

    $scope.clearPrice(keepKeyword);
  };

  $scope.clearPrice = keepKeyword => {
    $scope.data.currencyType = $scope.data.currencyTypes ? $scope.data.currencyTypes[0] : null;

    if (keepKeyword) {
      $scope.applySearch(true);
    } else {
      $scope.clearKeyword();
    }
  };

  $scope.clearKeyword = () => {
    $scope.searchLayout.keyword = null;
    $scope.applySearch(true);
  };

  const clearFilters = $scope.$on(catalogConstants.clearFiltersEvent, (event, args) => {
    let keepKeyword = false;

    if (args && args.keepKeyword) {
      keepKeyword = true;
    }

    $scope.clearGenres(false, keepKeyword);
  });

  $scope.$on('$destroy', () => {
    if (clearFilters) {
      clearFilters();
    }
  });
}

catalogModule.controller('breadcrumbsController', breadcrumbsController);

export default breadcrumbsController;
